import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {StateService} from "@uirouter/angular";
import {MatDialog} from "@angular/material";
import {PartnerType} from "../../../../../classes/partnerType";
import {kanPartnerTypeDialog} from "../../../dialogs/partner-type-dialog/component";

@Component({
    selector: 'kan-partner-type-list-item',
    templateUrl: './component.html',
    styleUrls: ['./component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class kanPartnerTypeListItem {
    @Input() partnerType: PartnerType;
    @Output() refresh: EventEmitter<any> = new EventEmitter();

    constructor(private stateService: StateService,
                private dialog: MatDialog) {
    }

    ngOnInit(): void {

    }

    public edit(event) {
        let dialogRef = this.dialog.open(kanPartnerTypeDialog, {
            data: {
                partnerType: this.partnerType
            },
            disableClose: true,
            width: '800px'
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result === 'update') {
                this.refresh.emit();
            }
        });
    }

    public remove(event) {
        // let dialogRef = this.dialog.open(kanRemoveDialog, {
        //     disableClose: true
        // });
        //
        // dialogRef.afterClosed().subscribe((result) => {
        //     if (result === 'remove') {
        //         this.servicesService.removeService(this.service)
        //             .then((data) => {
        //                 this.refresh.emit();
        //             });
        //     }
        // });
    }
}



// WEBPACK FOOTER //
// ./src/modules/admin/components/partner-type/list-item/component.ts